<div class="iti iti--allow-dropdown flex"
	[ngClass]="separateDialCodeClass">
  <p-select styleClass="surface-200 border-right-none px-0 w-5rem border-noround-right shadow-none" [options]="allCountries" [(ngModel)]="selectedCountry" optionLabel="name" [filter]="true" filterBy="name"
	 placeholder="Select a Country">
	<ng-template pTemplate="selectedItem">
		<div class="text-sm" *ngIf="selectedCountry">
			<div class="iti__flag-box">
				<div class="iti__flag" [ngClass]="selectedCountry.flagClass"></div>
			</div>
		</div>
	</ng-template>
	<ng-template let-country pTemplate="item">
    <li class="iti__country iti__standard text-sm flex align-items-center w-18rem md:w-11rem lg:w-13rem px-0"
					[id]="country.htmlId">
					<div class="iti__flag-box">
						<div class="iti__flag"
							[ngClass]="country.flagClass"></div>
					</div>
					<span class="iti__country-name mx-2 break-word">{{country.name}}</span>
					<span class="iti__dial-code">+{{country.dialCode}}</span>
				</li>
	</ng-template>
</p-select>

	<input type="tel"
		class="w-full text-sm border-left-none border-noround-left"
		pInputText
		[id]="inputId"
		autocomplete="off"
		[ngClass]="cssClass"
		(blur)="onTouched()"
		(keypress)="onInputKeyPress($event)"
		[(ngModel)]="phoneNumber"
		(ngModelChange)="onPhoneNumberChange()"
		[disabled]="disabled"
		[placeholder]="resolvePlaceholder()"
		[attr.maxLength]="maxLength"
		[attr.validation]="phoneValidation"
		#focusable>
</div>



